export interface SocialCounts {
  followersCount: number;
  followingCount: number;
  friendsCount: number;
}
